import { FeatureAppMode } from '@ngw6fa/feature-app';
import { AppConstants, FeatureAppNames } from './app-constants';
import { isTruthy } from './is-truthy';
import { FAServicesParams } from '../types/service-configs';

export interface ModelOverviewIntegratorQueryParams {
  readonly carlineId?: string;
  readonly countryCode?: string;
  readonly currency?: string;
  readonly language?: string;
  readonly mode?: string;
  readonly faServicesUrl: string;
  readonly salesgroupId?: string;
  readonly showroomNodeId?: string;
  readonly trimName?: string;
  readonly ssr?: string;
  readonly galleryPath?: any;
  readonly galleryImages?: any;
  readonly youtubePlayerConfig?: any;
  readonly graphQLServerUrl?: string;
  readonly featureAppName: string;
  readonly faServicesParams?: FAServicesParams;
}

export interface ModelOverviewIntegratorOptions {
  readonly carlineId?: string;
  readonly countryCode: string;
  readonly currency: string;
  readonly language: string;
  readonly mode: FeatureAppMode;
  readonly faServicesUrl: string;
  readonly salesgroupId?: string;
  readonly showroomNodeId?: string;
  readonly trimName?: string;
  readonly ssr?: boolean;
  readonly baseUrl?: string;
  readonly galleryPath?: any;
  readonly galleryImages?: any;
  readonly youtubePlayerConfig?: any;
  readonly graphQLServerUrl?: string;
  readonly featureAppName?: string;
  readonly faServicesParams?: FAServicesParams;
}

const getMode = (modeQueryParam: string | undefined): FeatureAppMode => {
  if (!modeQueryParam) {
    return 'default';
  }
  return modeQueryParam;
};

export const getFeatureAppName = (
  featureAppName: string | undefined,
): string => {
  const featureAppNames: string[] = Object.values(FeatureAppNames);
  if (!featureAppName || !featureAppNames.includes(featureAppName)) {
    return 'default';
  }
  return featureAppName;
};

const galleryImagesDefault = [
  {
    image: 'Tig-20-0240-Gallery.jpg',
    cutline:
      'Up to 73.5 cubic feet of cargo capacity with rear seats folded down.',
    alt: 'This alt text is from gallery FA config json',
  },
  {
    image: 'Tig-20-0244-Gallery.jpg',
    cutline:
      'Tiguan SEL Premium R-Line with 4MOTION® shown in Storm Gray Vienna Leather.',
  },
  {
    image: 'Tig-20-0246-Gallery.jpg',
    cutline: 'Available Climatronic® dual-zone automatic climate control.',
  },
  {
    image: 'Tig-20-0271-Gallery.jpg',
    cutline:
      "Available Discover Media touchscreen navigation system with 8'' glass display.",
  },
  {
    image: 'Tig-20-0272-Gallery.jpg',
    cutline: 'Available panoramic sunroof.',
  },
  {
    image: 'Tig-20-0273-Gallery.jpg',
    cutline:
      'Tiguan SEL Premium R-Line with 4MOTION® shown in Titan Black Vienna Leather.',
  },
  {
    image: 'Tig-20-0402-Gallery.jpg',
    cutline: 'Available 3rd-row seating.',
  },
  {
    image: 'Tig-20-1138-Gallery.jpg',
    cutline:
      'Tiguan SEL Premium R-Line with 4MOTION shown in Titan Black Vienna Leather.',
  },
  {
    image: 'Tig-20-0235-Gallery.jpg',
    cutline:
      'Tiguan SEL Premium R-Line with 4MOTION® shown in Silk Blue Metallic.',
  },
  {
    image: 'Tig-20-0237-Gallery.jpg',
    cutline:
      'Available LED headlights with Adaptive Front-lighting System (AFS) and LED Daytime Running Lights.',
  },
  {
    image: 'Tig-20-0238-Gallery.jpg',
    cutline: 'LED taillights.',
  },
  {
    image: 'Tig-20-0274-Gallery.jpg',
    cutline:
      'Tiguan SEL Premium R-Line with 4MOTION® shown in Silk Blue Metallic.',
  },
  {
    image: 'Tig-20-0275-Gallery.jpg',
    cutline:
      'Tiguan SEL Premium R-Line with 4MOTION® shown in Silk Blue Metallic.',
  },
  {
    image: 'Tig-20-0276-Gallery.jpg',
    cutline:
      'Tiguan SEL Premium R-Line with 4MOTION® shown in Silk Blue Metallic.',
  },
  {
    image: 'Tig-20-0277-Gallery.jpg',
    cutline: 'Available hands-free Easy Open and Easy Close liftgate.',
  },
  {
    image: 'Tig-20-0278-Gallery.jpg',
    cutline:
      'Tiguan SEL Premium R-Line with 4MOTION® shown in Silk Blue Metallic.',
  },
  {
    image: 'prueba1.jpg',
    cutline: 'Testing Testing....',
    alt: 'This alt text is from gallery FA config json',
  },
];

export function createOptionsFromQueryParams(
  queryParams: ModelOverviewIntegratorQueryParams,
): ModelOverviewIntegratorOptions & any {
  const {
    carlineId,
    countryCode = 'US',
    currency = 'USD',
    language = 'en',
    faServicesUrl = AppConstants.APP_ENVIRONMENT === 'dev'
      ? 'https://dev.services.ngw6apps.io'
      : 'https://qa.vwservicesfa.svc.vwusa.io',
    mode: modeQueryParam,
    salesgroupId,
    showroomNodeId,
    ssr,
    trimName,
    galleryPath = '/api/assets/onehub_pkw/us/en/gallery/',
    galleryImages = galleryImagesDefault,
    featureAppName,
    faServicesParams = AppConstants.APP_ENVIRONMENT === 'dev'
      ? {
          urlOrigin: 'https://qa.vw.com',
          urlPath: '/en.service-config.json',
          credentials: {
            username: 'cmuser',
            password: 'IdVL9f9uA9Q5',
          },
        }
      : {
          urlOrigin: 'https://cs-int-vw-us.lighthouselabs.eu',
          urlPath: '/en.service-config.json',
          credentials: {
            username: 'onehub-cms-user',
            password: 'Tp5a38TCiosv',
          },
        },
  } = queryParams;

  return {
    carlineId,
    countryCode,
    currency,
    language,
    faServicesUrl,
    galleryImages,
    galleryPath,
    mode: getMode(modeQueryParam),
    salesgroupId,
    showroomNodeId,
    ssr: isTruthy(ssr),
    baseUrl: isTruthy(ssr) ? process.env.BASE_URL : '',
    trimName,
    featureAppName: getFeatureAppName(featureAppName),
    faServicesParams,
  };
}
